import { ApiParameters } from './api-parameters';
import { ApiPutRequest } from './api-put-request';
import { SimplePlayer } from '../../simple-player';

export class PlayerPermissionsPutRequest extends ApiPutRequest
{

    public constructor(
        Player: SimplePlayer,
        webapiBasepath: string
    )
    {
        super(  'player/permissions', 
                new ApiParameters(), 
                null, 
                {
                    Player
                },
                webapiBasepath
            );
    }
}
